<template>
    <div class="pagination">
      <button
        v-for="page in pages"
        :key="page"
        :class="{ active: page === current }"
        @click="$emit('change', page)"
      >
        {{ page }}
      </button>
  
      <button @click="$emit('next')">Next</button>
    </div>
  </template>
  
  <script>
  export default {
    name: "ProfilePagination",
    props: {
      current: Number,
      pages: Array
    }
  };
  </script>
  
  <style scoped>
  .pagination {
    display: flex;
    justify-content: center;
    gap: 10px;
    margin: 30px 0;
  }
  
  button {
    background: transparent;
    border: 1px solid #444;
    color: #fff;
    padding: 6px 12px;
    border-radius: 6px;
  }
  
  button.active {
    background: #ff4f8b;
    border-color: #ff4f8b;
  }
  </style>
  